import {
  Box,
  Container,
  Flex,
  Heading,
  Table,
  Td,
  Th,
  Tr,
} from "@chakra-ui/react";

export function About() {
    
  return (
    <div   id="about" class="about section">
      <Heading textAlign={"center"}mb={"25px"}>
        About Me
      </Heading>
      <Flex  id="about" className="about section"
        justifyContent={["center", "center", "space-evenly"]}
        alignItems="center"
        // fontSize={"28px"}
        direction={["column", "column", "row"]}
        gap="50px"
        // border={"1px solid green"}
      >
        <Box>
        <Table
          variant="simple"
          size={"md"}
          fontSize={"16px"}
          width={["12rem", "32rem", "32rem"]}
          className="aboutTable"
          margin="auto"
        //   border={"1px solid blue"}
        >
          <Tr>
            <Th>Name</Th>
            <Td id="user-detail-name">Shubham Pandey</Td>
          </Tr>
          <Tr>
            <Th>Higher Education</Th>
            <Td>Bachelor of Arts</Td>
          </Tr>
          <Tr>
            <Th>Address</Th>
            <Td>
              Delhi,
              India.
            </Td>
          </Tr>
          
          <Tr>
            <Th>Contact NO.</Th>
            <Td>+91 8707435856</Td>
          </Tr>
          <Tr>
            <Th>Email ID</Th>
            <Td>pandeyaashu4@gmail.com</Td>
          </Tr>
        </Table>
        </Box>
        <Box>
          <Container
            textAlign={"justify"}
            fontSize={"18px"}
            maxHeight={["20rem", "20rem", "33rem"]}
            overflowY={["scroll", "scroll", "hidden"]}
            p={"0px 20px 0px 20px"}
          >
            <p  id="user-detail-intro">Hello My name is Shubham Pandey I am Full stack Web Developer and I enjoy learning new things in web development. I'm passionate Developer, with good attention to detail and the ability to write efficient code using MERN Stack My interest in web devlopment started last year when i was know about coding how we create beautiful website using code that things attrack me a lot to know how to website created and then I started knowing about this on Internet that taught me a lot about HTML & CSS and then I decide my carrier as a web Devloper. </p>
          </Container>
        </Box>
      </Flex>
    </div>
  );
}
